/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchGetUiAcknowledgements} from '../api'

export const useMutationBatchGetUiAcknowledgements = createReactQueryMutationHook('batchGetUiAcknowledgements', batchGetUiAcknowledgements)
